module.exports = __webpack_public_path__ + "static/firepit_static-3658541873c1bde566ef4f710e69cd09.png";